/**
 * Westdale Peptides — Product Page
 * Handles: variant selection, image gallery, quantity controls, AJAX add-to-cart
 */
(function () {

  // ── Toast ──────────────────────────────────────────────────────
  var _toastEl = null, _toastTimer = null;

  function showToast(msg, type) {
    if (!document.getElementById('wp-prod-toast-css')) {
      var s = document.createElement('style');
      s.id = 'wp-prod-toast-css';
      s.textContent =
        '.wp-prod-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(16px);' +
        'background:#1A1A2E;color:#fff;padding:13px 20px;border-radius:12px;' +
        'display:flex;align-items:center;gap:12px;font-size:14px;font-weight:600;' +
        'box-shadow:0 8px 32px rgba(0,0,0,0.28);border:1px solid rgba(124,58,237,0.45);' +
        'z-index:99999;pointer-events:none;opacity:0;' +
        'transition:opacity 280ms ease,transform 280ms ease;white-space:nowrap;}' +
        '.wp-prod-toast.is-err{border-color:rgba(220,38,38,0.5);}' +
        '.wp-prod-toast.is-on{opacity:1;transform:translateX(-50%) translateY(0);}' +
        '.wp-prod-toast__ico{width:30px;height:30px;flex-shrink:0;border-radius:7px;' +
        'display:flex;align-items:center;justify-content:center;}' +
        '.wp-prod-toast__ico--ok{background:linear-gradient(135deg,#7C3AED,#A78BFA);}' +
        '.wp-prod-toast__ico--err{background:#DC2626;}' +
        '.wp-prod-toast__ico svg{width:15px;height:15px;fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}';
      document.head.appendChild(s);
    }
    if (!_toastEl) {
      _toastEl = document.createElement('div');
      _toastEl.className = 'wp-prod-toast';
      _toastEl.setAttribute('role', 'status');
      _toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(_toastEl);
    }
    var isErr = type === 'error';
    _toastEl.className = 'wp-prod-toast' + (isErr ? ' is-err' : '');
    _toastEl.innerHTML =
      '<div class="wp-prod-toast__ico ' + (isErr ? 'wp-prod-toast__ico--err' : 'wp-prod-toast__ico--ok') + '" aria-hidden="true">' +
        (isErr
          ? '<svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>'
          : '<svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>') +
      '</div>' +
      '<span>' + msg + '</span>';
    clearTimeout(_toastTimer);
    void _toastEl.offsetWidth;
    _toastEl.classList.add('is-on');
    _toastTimer = setTimeout(function () { _toastEl.classList.remove('is-on'); }, 3200);
  }

  document.addEventListener('wp:free-gifts-added', function (event) {
    var gifts = event.detail && event.detail.gifts || [];
    if (!gifts.length) return;
    event.detail.handled = true;
    var list = gifts.length === 1 ? gifts[0] : gifts.slice(0, -1).join(', ') + ' and ' + gifts[gifts.length - 1];
    showToast('Added to cart with free gift' + (gifts.length === 1 ? ': ' : 's: ') + list + '.');
  });

  // ── Cart badge ─────────────────────────────────────────────────
  function updateBadge(count) {
    var cartLink = document.querySelector('.wp-nav__icon--cart');
    if (cartLink) {
      var badge = cartLink.querySelector('.wp-nav__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'wp-nav__badge';
          badge.setAttribute('aria-hidden', 'true');
          cartLink.appendChild(badge);
        }
        badge.textContent = count;
        cartLink.setAttribute('aria-label', 'Cart (' + count + ' items)');
      } else {
        if (badge) badge.remove();
        cartLink.setAttribute('aria-label', 'Cart');
      }
    }
  }

  document.querySelectorAll('.wp-product-form').forEach(form => {
    const variantInput = form.querySelector('[name="id"]');
    const priceEl      = form.closest('.wp-product__info')?.querySelector('.wp-product__price');
    const compareEl    = form.closest('.wp-product__info')?.querySelector('.wp-product__price-compare');
    const atcBtn       = form.querySelector('.wp-product__atc-btn');
    const productJSON  = document.getElementById('wp-product-json');

    if (!variantInput || !productJSON) return;

    const product = JSON.parse(productJSON.textContent);

    // Build option → value state (one per option group)
    const selectedOptions = product.options.map((_, i) => {
      const active = form.querySelector(`.wp-product__option-btns[data-option-index="${i}"] .wp-product__option-btn.is-active`);
      return active ? active.dataset.value : null;
    });

    function findVariant(opts) {
      return product.variants.find(v =>
        v.options.every((val, i) => opts[i] === null || opts[i] === val)
      ) || null;
    }

    function updateVariant() {
      const variant = findVariant(selectedOptions);
      if (!variant) return;

      variantInput.value = variant.id;

      // Price
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      // ATC button
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Gallery: switch to variant image if it has one
      const varImg = variant.featured_image;
      if (varImg) switchMainImage(varImg.src.replace(/(\.[^.]+)$/, '_1024x1024$1'));
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Option button clicks
    form.querySelectorAll('.wp-product__option-btns').forEach(group => {
      const idx = parseInt(group.dataset.optionIndex, 10);
      group.querySelectorAll('.wp-product__option-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          group.querySelectorAll('.wp-product__option-btn').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          selectedOptions[idx] = btn.dataset.value;
          updateVariant();
        });
      });
    });

    // ── AJAX Add to Cart ───────────────────────────────────────
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const vid = parseInt(variantInput.value, 10);
      const qty = parseInt(form.querySelector('.wp-product__qty-input')?.value, 10) || 1;
      if (!vid || atcBtn?.disabled) return;

      const origText = atcBtn ? atcBtn.textContent : '';
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body:    JSON.stringify({ id: vid, quantity: qty })
      })
        .then(r => r.json())
        .then(data => {
          if (data.status) {
            showToast(data.description || 'Could not add to cart', 'error');
            if (atcBtn) { atcBtn.textContent = origText; atcBtn.disabled = false; }
            return;
          }
          if (atcBtn) atcBtn.textContent = 'Added ✓';
          showToast('Added to cart!');
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => updateBadge(cart.item_count));
          setTimeout(() => {
            if (atcBtn) { atcBtn.textContent = origText; atcBtn.disabled = false; }
          }, 2000);
        })
        .catch(() => {
          showToast('Something went wrong — try again', 'error');
          if (atcBtn) { atcBtn.textContent = origText; atcBtn.disabled = false; }
        });
    });

    // Quantity +/-
    form.querySelectorAll('.wp-product__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = form.querySelector('.wp-product__qty-input');
        if (!input) return;
        const current = parseInt(input.value, 10) || 1;
        const delta   = btn.dataset.qty === '+' ? 1 : -1;
        input.value   = Math.max(1, current + delta);
      });
    });
  });

  // ── Gallery thumbnail switcher ─────────────────────────────
  document.querySelectorAll('.wp-product__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      switchMainImage(thumb.dataset.src, thumb.dataset.srcset);
      document.querySelectorAll('.wp-product__thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  function switchMainImage(src, srcset) {
    const main = document.getElementById('wp-main-img');
    if (!main) return;
    main.style.opacity = '0';
    setTimeout(() => {
      if (src) main.src = src;
      if (srcset) main.srcset = srcset;
      main.style.opacity = '1';
    }, 150);
  }
})();
